import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

export default function SimpleDialog(props) {
  const { onClose, title, open, msg } = props;

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>{title}</DialogTitle>
        <Typography id="modal-modal-description" sx={{ mt: 2, mx: 3, mb: 3 }}>
        {msg}
        </Typography>
      
    </Dialog>
  );
}

SimpleDialog.propTypes = {
    title: PropTypes.string.isRequired,
    msg: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};